import classes from '@/components/pillBar/PillBar.module.scss';
import classNames from 'classnames';
import type { ReactNode } from 'react';

const PillBar: React.FC<{ children: ReactNode }> = ({ children }) => (
  <div data-testid="pill-bar-component" className={classNames('PillBar', classes.PillBar)}>
    <div className={classes.PillBarInner}>{children}</div>
  </div>
);

export default PillBar;
